module.exports = __webpack_public_path__ + "img/portrait-093.449bd422.jpg";